import './App.css';
import { BrowserRouter, Route, Routes, Link, useNavigate, useLocation } from 'react-router-dom';
import CompShowInicio from './components/inicio.js';
import CompShowLogin from './components/login';
import CompInventario from './components/inventario';
import CompCrearProducto from './components/crearProducto.js';
import CompCarrito from './components/carrito';
import CompCrearDescuento from './components/createDescuento';
import CompShowVentas from './components/showVentas';
import CajaManager from './components/caja/cajaManager';
import { SidebarProvider, useSidebar } from './components/sidebarContext';
import CompSidebar from './components/sideBar';
import HistorialCajas from './components/caja/historialCaja';
import IngresoStock from './components/ingreso.js';
import { FaBars, FaArrowLeft } from 'react-icons/fa';
import CompGestionStockMenu from './components/menus/gestionStockMenu.js';
import { AuthProvider } from './context/AuthContext'; // Contexto para manejo de roles
import PrivateRoute from './components/privateRoute.js'; // Componente para validar roles
import ProtectedByCodeRoute from './components/ProtectedByCodeRoute';
import CompCajaMenu from './components/menus/cajaMenu.js';
import Egreso from './components/egreso.js';
import CompShowIngresos from './components/historialIngresos.js';
import CompShowEgresos from './components/historialEgresos.js';
import * as Sentry from '@sentry/react'
import { ToastContainer } from 'react-toastify';
import CompClientesMenu from './components/clientes/compClientes.js';
import 'react-toastify/dist/ReactToastify.css';
import CompVendedoresMenu from './components/menus/compVendedoresMenu.js';
import CompRegistrarVendedor from './components/vendedores/registrarVendedor.js';
import CompVendedores from './components/vendedores/compVendedores.js';
import CompCombinaciones from './components/CompCombinaciones.js';
import DevolucionVenta from './components/devolucion.js';
import HistorialDevoluciones from './components/historialDevoluciones.js';
import HistorialDevolucionesAvanzado from './components/historialDevolucionesAvanzado.js';
const ToggleButton = () => {
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const navigate = useNavigate();
  const location = useLocation();

  const handleBackNavigation = () => {
    // Si estamos en una ruta de venta, ir al inicio
    if (location.pathname.startsWith('/venta/')) {
      navigate('/');
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="fixed top-4 left-4 z-50 flex items-center space-x-4 bg-gray-200 p-1  rounded-lg shadow-lg">
      <button
        onClick={toggleSidebar}
        className={`bg-indigo-600 text-white p-2 rounded-full shadow-md transition-transform duration-300 hover:bg-indigo-700 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-indigo-400 ${isSidebarOpen ? 'rotate-90' : ''}`}
        aria-label={isSidebarOpen ? 'Cerrar Sidebar' : 'Abrir Sidebar'}
      >
        <FaBars size={20} />
      </button>

      <button
        onClick={handleBackNavigation}
        className="text-black font-semibold text-lg hover:text-indigo-400 transition-colors duration-200"
        aria-label="Volver"
      >
        <FaArrowLeft size={24} />
      </button>
    </div>

  );
};

function App() {
  return (

    <BrowserRouter>
      <AuthProvider>
        <SidebarProvider>
          <div>
            <ToggleButton />
            <CompSidebar />
            <ToastContainer
            />
            <Routes>
              {/* Ruta pública */}
              <Route path="/" element={
                <PrivateRoute allowedRoles={['admin', 'seller']}>
                  <CompShowInicio />
                </PrivateRoute>
              } />


              <Route path="/login" element={<CompShowLogin />} />

              {/* Rutas protegidas */}

              <Route
                path="/inventario"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <CompInventario />
                  </PrivateRoute>
                }
              />
              <Route
                path="/caja/historial"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <ProtectedByCodeRoute requiredCode="4321" label="Código para ver el historial de cajas">
                      <HistorialCajas />
                    </ProtectedByCodeRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/caja"
                element={
                  <PrivateRoute allowedRoles={['admin', 'seller']}>
                    <CajaManager />
                  </PrivateRoute>
                }
              />
              <Route
                path="/crear-producto"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <CompCrearProducto />
                  </PrivateRoute>
                }
              />
              <Route
                path="/venta/:tipo"
                element={
                  <PrivateRoute allowedRoles={['seller', 'admin']}>
                    <CompCarrito />
                  </PrivateRoute>
                }
              />

              <Route
                path="/ventas"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <CompShowVentas />
                  </PrivateRoute>
                }
              />
              <Route
                path="/devolucion/:id_venta"
                element={
                  <PrivateRoute allowedRoles={['admin', 'seller']}>
                    <DevolucionVenta />
                  </PrivateRoute>
                }
              />
              <Route
                path="/devolucion"
                element={
                  <PrivateRoute allowedRoles={['admin', 'seller']}>
                    <DevolucionVenta />
                  </PrivateRoute>
                }
              />
              <Route
                path="/historial-devoluciones"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <HistorialDevoluciones />
                  </PrivateRoute>
                }
              />
              <Route
                path="/historial-devoluciones-avanzado"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <HistorialDevolucionesAvanzado />
                  </PrivateRoute>
                }
              />
              <Route
                path="/gestion-stock"
                element={
                  <PrivateRoute allowedRoles={['admin', 'seller']}>
                    <CompGestionStockMenu />
                  </PrivateRoute>
                }
              />

              <Route
                path="/caja"
                element={
                  <PrivateRoute allowedRoles={['admin', 'seller']}>
                    <CompCajaMenu />
                  </PrivateRoute>
                }
              />
              <Route
                path="/ingreso"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <IngresoStock />
                  </PrivateRoute>
                }
              />
              <Route
                path="/egreso"
                element={
                  <PrivateRoute allowedRoles={['admin', 'seler']}>
                    <Egreso />
                  </PrivateRoute>
                }
              />
              <Route
                path="/historial-egresos"
                element={
                  <PrivateRoute allowedRoles={['admin', 'seler']}>
                    <CompShowEgresos />
                  </PrivateRoute>
                }
              />
              <Route
                path="/historial-ingresos"
                element={
                  <PrivateRoute allowedRoles={['admin', 'seler']}>
                    <CompShowIngresos />
                  </PrivateRoute>
                }
              />
              <Route
                path="/ofertas"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <CompCrearDescuento />
                  </PrivateRoute>
                }
              />
              <Route
                path="/clientes"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <CompClientesMenu />
                  </PrivateRoute>
                }
              />
              <Route
                path="/vendedores"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <CompVendedoresMenu />
                  </PrivateRoute>
                }
              />
              <Route
                path="/vendedores/crear"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <CompRegistrarVendedor />
                  </PrivateRoute>
                }
              />

              <Route
                path="/vendedores/todos"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <CompVendedores />
                  </PrivateRoute>
                }
              />


              <Route
                path="/combinaciones"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <CompCombinaciones />
                  </PrivateRoute>
                }
              />
            </Routes>
          </div>
        </SidebarProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default Sentry.withProfiler(App);
